import { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';

export function CustomSelect({ value, onChange, options, placeholder = 'Select...', testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = options.find(o => o.value === value);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid={testId}>
      <button type="button" onClick={() => setOpen(!open)}
        className={`w-full flex items-center justify-between bg-white border rounded-lg px-4 py-3 text-[14px] font-sans transition-all ${
          open ? 'border-[#1F3A34] ring-1 ring-[#1F3A34]/20' : 'border-[#E2DDD3] hover:border-[#D9D3C8]'
        } ${selected ? 'text-[#1C1C1C]' : 'text-[#D9D3C8]'}`}>
        <span className="truncate">{selected ? selected.label : placeholder}</span>
        <ChevronDown className={`w-4 h-4 text-[#8C877F] transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-[#E2DDD3] rounded-lg shadow-lg max-h-[240px] overflow-y-auto animate-fade-in"
          style={{ boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
          {options.map(opt => (
            <button key={opt.value} type="button"
              onClick={() => { onChange(opt.value); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-left text-[13px] font-sans transition-colors ${
                opt.value === value ? 'bg-[#E6EFEA] text-[#1F3A34] font-medium' : 'text-[#1C1C1C] hover:bg-[#F4F1EB]'
              }`}>
              {opt.value === value && <Check className="w-3.5 h-3.5 text-[#1F3A34] flex-shrink-0" />}
              <div className="flex-1 min-w-0">
                <span className="block truncate">{opt.label}</span>
                {opt.sub && <span className="block text-[11px] text-[#8C877F] truncate">{opt.sub}</span>}
              </div>
            </button>
          ))}
          {options.length === 0 && <p className="px-4 py-3 text-[13px] text-[#8C877F]">No options available</p>}
        </div>
      )}
    </div>
  );
}
